import { IUserDetails } from "src/types";

export const detectSuperAdmin = (row: IUserDetails) => {
    const data = row.roles.find((role) => role.title === "Super Admin");
    const isSuperAdmin = data ? true : false
    return isSuperAdmin;
}